import {
  ActionDependant,
  evaluateTemplateValue,
  GlobalDataContext,
  TemplateContext,
  View,
} from '@ea-lab/reactive-json';
import { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const titleCache = new Map();
const MAX_CACHE_SIZE = 200;

export const DocPageLink = ({ props, path = '', currentData, datafield = 'content' }) => {
  const globalDataContext = useContext(GlobalDataContext);
  const templateContext = useContext(TemplateContext);
  const navigate = useNavigate();
  const [title, setTitle] = useState(null);

  const rawId = evaluateTemplateValue({
    valueToEvaluate: props.pageId,
    globalDataContext,
    templateContext,
  });
  const id = rawId != null && rawId !== '' && Number.isFinite(Number(rawId)) ? Number(rawId) : null;
  const href = id ? `/docs/page/${id}` : '#';
  const attributes = props.attributes || {};

  useEffect(() => {
    if (!id) return;
    if (titleCache.has(id)) {
      setTitle(titleCache.get(id));
      return;
    }
    let cancelled = false;
    fetch(`/decoupled-api/node/builder_page/${id}?display=decoupled`, { credentials: 'include' })
      .then((r) => r.ok ? r.json() : null)
      .then((json) => {
        if (cancelled) return;
        const t = json?.data?.title || `Document #${id}`;
        if (titleCache.size >= MAX_CACHE_SIZE) {
          const firstKey = titleCache.keys().next().value;
          if (firstKey !== undefined) titleCache.delete(firstKey);
        }
        titleCache.set(id, t);
        setTitle(t);
      })
      .catch(() => {
        if (!cancelled) setTitle(`Document #${id}`);
      });
    return () => { cancelled = true; };
  }, [id]);

  const hasCustomContent = props?.content;

  if (!id) {
    return (
      <ActionDependant {...props}>
        <span className={attributes.class}>Document inconnu</span>
      </ActionDependant>
    );
  }

  return (
    <ActionDependant {...props}>
      <a href={href} onClick={(e) => { if (id) { e.preventDefault(); navigate(href); } }} className={attributes.class}>
        {hasCustomContent ? (
          <View
            props={props.content}
            path={path + '.content'}
            currentData={currentData?.[datafield]}
            datafield={datafield}
          />
        ) : (
          title ?? `Document #${id}`
        )}
      </a>
    </ActionDependant>
  );
};
